<div class="picker-container">
  <swiper
  class="picker-swiper"
  [slidesPerView]="5"
  [centeredSlides]="true"
   [mousewheel]="{ releaseOnEdges: true, forceToAxis: true }"
  [spaceBetween]="0"
  (slideChange)="onSlideChange()"
  (swiper)="onSwiperInit($event)"
>
  <ng-template swiperSlide *ngFor="let num of numberList">
    <div
      class="picker-slide"
      [class.active]="num === value"
    >
      {{ num }}
    </div>
  </ng-template>
</swiper>

</div>
